import { api } from '@/v2/plugins/axios';

const API_PATH = '/v1/whatsapp/catalog/linked-categories';
const API_PATH_PRODUCTS = '/v1/whatsapp/products';

class Category {
    id = undefined;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static fetch = async (queryParams) => {
		try {
			const { data: responseData } = await api.get(`${API_PATH}`, {
				params: queryParams,
			});

			const { result } = responseData;
			const { data } = result;

			return {
				data: data.map((obj) => {
					return new Category(obj);
				}),
				totalRecords: result?.total,
			};
		} catch (e) {
			console.log(e);
		}
	};

	static create = async (data) => {
        return api.post(API_PATH, data);
	};

	static getList = async (params) => {
        const res = await api.get(`${API_PATH}`, { params });
        const data = res?.data?.result?.data;
        const totalRecords = res?.data?.result?.total;

        return {
            data,
            totalRecords,
        };
	};

	get = async () => {
        return api.get(`${API_PATH}/${this.id}`);
	};

	update = async (data) => {
        return api.patch(`${API_PATH}/${this.id}`, data);
	};

    static bulkCreate = async (main_category_ids) => {
        return api.post(`${API_PATH}/bulk-create`, {main_category_ids});
	};

	remove = async () => {
        return api.delete(`${API_PATH}/${this.id}`);
	};

    static getMainCategory = async (params) => {
        const res = await api.get(`${API_PATH_PRODUCTS}/main-categories`, { params });

        const categories = res?.data?.result?.categories;
        const data = categories?.data?.map(el=> {
            return {
                ...el,
                available_name: el.available_name ?? el.translations?.[0]?.title
            }
        });

        const totalRecords = categories?.total;

        return {
            data,
            totalRecords,
        };
    };

    assignProducts = async (product_ids) => {
        return api.post(`${API_PATH}/${this.id}/assign-products`, {product_ids});
    };
}

export default Category;
